var noFake = new Vue({
    el:'#noFake',
    data(){
        return{
            info:{
                name:'',
                country:'Country',
                email:'',
                type:'Category',
                link:'',
                product:'Fake Product Model',
                channel:'Purchase Channel',
                message:''
            },
            data:[],
            tipFlag:false,
            submitFlag:true,
            popup1:false,
            select_flag1:0,
            popup2:false,
            select_flag2:0,
            popup3:false,
            select_flag3:0,
            popup4:false,
            select_flag4:0,
            countryArr:[],
            findText:'',
            typeArr:['Fake Product','Fake Website','Fake Account','Fake Purchase Channel','Others'],
            productArr:['NeXLIM','VPRIME','XLIM PRO 2','XLIM CLASSIC EDITION','XLIM GO','XLIM SE 2','XLIM SQ PRO',
                'ONEO','XLIM PRO','XLIM TOP FILL CARTRIDGE','XLIM EZ CARTRIDGE','XLIM POD','XLIM SE','XLIM SQ','XLIM C','Others'],
            channelArr:['Offline Store','Online Store','Others']
        }
    },
    methods:{
        async submitForm(){
            if(!this.submitFlag){
                showMessage('Sending, please wait...','success')
                return;}
            if(this.info.name==''||this.info.email==''||this.info.country=='Country'||this.info.type=='Category'|| this.info.message==''){
                showMessage('Please fill in the information completely','error')
                return;
            }
            if(this.info.type!='Fake Website' && this.info.type!='Fake Account'){
                if(this.info.product=='Fake Product Model' || this.info.channel=='Purchase Channel'){
                    showMessage('Please fill in the information completely','error')
                    return;
                }
            }
            if(this.info.type=='Fake Website'){
                if(this.info.link==''){
                    showMessage('Please fill in the information completely','error')
                    return;
                }
            }
            if(this.data.length==0){
                showMessage('Please upload pictures','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.info.email)){
                    showMessage('Sending, please wait...','success')
                    this.submitFlag = false

                    //上传文件
                    const formData = new FormData();
                    for(var i=0;i<this.data.length;i++){
                        formData.append("files", this.data[i]);
                    }
                    let res=await axios.post('https://service.oxvatech.cn/email/upload',formData,{headers: {
                        'Content-Type': 'multipart/form-data'
                    }});
                    if(res.status==200){
                        let filesArr = res.data.files;

                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.info));
                        params.append('filesArr',JSON.stringify(filesArr));
                        let result=await axios.post('https://service.oxvatech.cn/email/noFake',params);
                        if(result.status == 200){
                            showMessage('Sent successfully','success')
                            setTimeout(() => {
                                window.location.reload()
                            }, 500);
                        }else{
                            showMessage('Error! please contact us','error')
                        }
                    }else{
                        showMessage('Error! please contact us','error')
                    }
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        upload(event){
            var file = event.target.files[0]
            if(file.size>10*1024*1024){
                showMessage('The uploaded file cannot exceed 10M','error')
                return;
            }else if(this.data.length==9){
                showMessage('Upload up to 9 files','error')
                return;
            }else{
                this.data.push(file)
            }
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 计算目标元素相对于父容器的偏移量
                var targetOffsetTop = targetCountry.offsetTop;

                // 设置父容器的滚动位置，使目标元素与父容器顶部对齐
                countryList.scrollTop = targetOffsetTop;
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        reportNow(){
            var element = document.querySelector(".box3");
            element.scrollIntoView({block: "start"});
        }
    },
    created(){
        this.getCountry()
    },
    mounted(){
        this.getCountry()
        if(window.innerWidth>750){
            var Wflag=true, box2S=12000,box2V=1.5,box2A='top top+=4%',box4V=3.5
        }else{
            Wflag=false,box2S=8000,box2V=0.8,box2A='top top+=6%',box4V=1.2
        }

        new Swiper('.box4Swiper', {
            slidesPerView: box4V,
            centeredSlides: true,
            autoplay: true,
            loop:true
        })
        
        new Swiper('.box2Swiper1', {
            speed:box2S,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            slidesPerView :box2V,
            loop:true
        }) 
        setTimeout(() => {
            new Swiper('.box2Swiper1', {
                speed:box2S,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                },
                slidesPerView :box2V,
                loop:true
            })  
        }, 2000);
        
        // -200%,20deg
        gsap.timeline({
            scrollTrigger:{
                trigger:'.box2',
                start:'top+=50% top+=6%',
                end:'+=320%',
                scrub:true
            }
        })
            .to('.box2_mask',{opacity:0})
            .from('.box2_content',{opacity:0})
            .to('.box2_items .box2_item:nth-child(4)',{y:'-200%',rotate:'20deg',delay:0.5,duration:1})
            .to('.box2_items .box2_item:nth-child(3)',{y:'-200%',rotate:'20deg',delay:0.5,duration:1})
            .to('.box2_items .box2_item:nth-child(2)',{y:'-200%',rotate:'20deg',delay:0.5,duration:1})
        
        ScrollTrigger.create({
            trigger:'.box2',
            start:box2A,
            end:'+=400%',
            // markers:true,
            pin:true
        })

        if(Wflag){
            ScrollTrigger.create({
                trigger:'.box3',
                start:'top center',
                end:'+=0',
                // markers:true,
                // toggleActions:'play none none reverse',
                animation:gsap.timeline().from('.box3_left',{x:'-150%',duration:1}).from('.box3_right',{x:'150%',duration:1},'<')
            })

            ScrollTrigger.create({
                trigger:'.box4',
                start:'top center-=20%',
                end:'+=0',
                // markers:true,
                // toggleActions:'play none none reverse',
                animation:gsap.timeline().from('.box4Swiper',{y:'4rem',opacity:0})
            })
        }

        gsap.from('.box4_title',{
            y:'2rem',opacity:0,duration:0.5,
            scrollTrigger:{
                trigger:'.box4_title',
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
                // markers:true
            }
        })
    }
})